import { PropsWithChildren, ReactNode } from 'react';
import clsx from 'clsx';

import { Icon, IconType } from '@@/Icon';

interface Props {
  icon?: IconType;
  label: React.ReactNode;
  description?: ReactNode;
  className?: string;
  id?: string;
}

export function TableTitle({
  icon,
  label,
  children,
  description,
  className,
  id,
}: PropsWithChildren<Props>) {
  return (
    <>
      <div className={clsx('toolBar flex-col', className)} id={id}>
        <div className="flex w-full items-center gap-x-3 gap-y-1 p-0">
          <h2 className="toolBarTitle m-0 text-base">
            {icon && (
              <div className="widget-icon">
                <Icon icon={icon} className="mr-1" />
              </div>
            )}
            {label}
          </h2>
          <div className="inline-flex items-center gap-1">{children}</div>
        </div>
      </div>
      {!!description && <div className="toolBar !pt-0">{description}</div>}
    </>
  );
}
